module.exports = __webpack_public_path__ + "img/youshi2.256737dc.webp";